
import { Component, Vue, Prop } from "vue-property-decorator";
import NewsItemM from "./components/NewsItemM.vue";
import { getNewsList, getNewsDetail } from "@/apis/about";
import Pagination from "@/components/pagination.vue";
import Breadcrumb from "@/components/Breadcrumb/index.vue";
import { formatUpyunUrl } from "@/utils";
import { getArticleJsonLd, getPersonJsonLd, getItemListJsonLd, injectJsonLd } from "@/utils/seo";
@Component({
  components: {
    NewsItemM,
    Pagination,
    Breadcrumb
  }
})
export default class Case extends Vue {
  formatUpyunUrl = formatUpyunUrl;
  total = 0;
  page = 1 as any;
  per_page = 12;
  list: any = [];
  index: any = 0;
  List = [
    { title: "关于光华", url: "" },
    { title: "光华动态", url: "/news" },
    { title: "内容详情", url: "" }
  ];
  info = {};
  id: any = "";
  loading = false;

  get relatedList() {
    if (!this.list || this.list.length === 0) return [];
    return this.list
      .filter((item: any) => item.id !== this.id)
      .slice(0, 3);
  }

  created() {
    // 优先从路径参数获取 id，兼容旧的 query 参数形式
    const routeId = this.$route.params.id || this.$route.query.id;
    if (routeId) {
      this.id = routeId as string;
    }
    if (this.$route.query.page) {
      this.page = this.$route.query.page;
    }
    this.page = this.page == 0 ? 1 : this.page;
    this.newsList();
    this.getNewsDetail();
  }
  handlePageChange(val: any) {
    this.page = val.page;
    this.newsList();
  }
  async newsList() {
    this.loading = true;
    const { data, total } = await getNewsList({
      page: this.page,
      per_page: this.per_page
    });
    this.total = total;
    if (this.list.length < this.total) {
      this.list.push(...data);
    }
    this.loading = false;
  }
  async getNewsDetail() {
    const data = await getNewsDetail({
      id: this.id
    });
    this.info = data;
    // 注入 Article JSON-LD
    if (data && data.title) {
      injectJsonLd(
        "jsonld-article",
        getArticleJsonLd({
          title: data.title,
          description: data.description || data.title,
          image: data.pic ? formatUpyunUrl(data.pic) : undefined,
          datePublished: data.create_time || data.update_time || undefined,
          dateModified: data.update_time || data.create_time || undefined,
          authorName: data.author || "朱莉莉",
          articleBody:
            typeof data.content === "string"
              ? data.content.replace(/<[^>]+>/g, "").substring(0, 500)
              : undefined
        })
      );
      // 注入 Person JSON-LD（作者实体）
      injectJsonLd(
        "jsonld-author-person",
        getPersonJsonLd({
          name: data.author || "朱莉莉",
          title: "光华赋能内容编辑",
          worksFor: "杭州光华赋能教育科技有限公司"
        })
      );
    }
    // 注入 ItemList JSON-LD（相关推荐）
    if (this.relatedList.length > 0) {
      injectJsonLd(
        "jsonld-related-list",
        getItemListJsonLd(
          this.relatedList.map((item: any) => ({
            name: item.title,
            url: `/news-detail?id=${item.id}`,
            image: item.pic ? formatUpyunUrl(item.pic) : undefined
          }))
        )
      );
    }
  }
  clickNews(item: any) {
    this.id = item.id;
    this.getNewsDetail();
  }

  onLazyLoad(event: any) {
    const { scrollTop, scrollHeight, clientHeight } = event.target;
    if (scrollTop + clientHeight >= scrollHeight - 10) {
      if (!this.loading) {
        this.page++;
        this.newsList();
      }
    }
  }

  mounted() {
    const metaTag1 = document.createElement("meta");
    metaTag1.setAttribute("name", "keywords");
    metaTag1.setAttribute(
      "content",
      "光华介绍，光华师资，光华动态，客户案例，效果看得见，"
    );
    document.head.appendChild(metaTag1);
    const metaTag2 = document.createElement("meta");
    metaTag2.setAttribute("name", "description");
    metaTag2.setAttribute(
      "content",
      "企业培训咨询数字化转型，找光华，企业培训咨询数字化转型 |，找光华，服务一万家企业绩效飞轮*应用实践，帮助一万家企业BLM科学经营T系统落地，到2035年，赋能陪跑企业合计GDP超一万亿规模，用科学经营助推企业高质量发展讲师说明：董权、霍振先、潘亦藩、蔡毅臣、杨波、方永飞 所有老师的名字动态说明：动态标题，客户案例说明：客户案例标题"
    );
    document.head.appendChild(metaTag2);
  }
}
